// Default product page: pick options, add to cart, open the side cart. Runs after cc-base.js, so window.CC is ready.
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var form = $('.ccp-pdp__form');
  if (!form) return;
  var T = function (k, en, v) { var d = window.CCI18N, s = (d && d[k]) || en; return v ? s.replace(/\{(\w+)\}/g, function (m, n) { return n in v ? v[n] : m; }) : s; };
  var variants = JSON.parse($('[data-ccp-variants]').textContent);
  var idField = $('[data-ccp-id]', form), add = $('[data-ccp-add]', form), price = $('[data-ccp-price]');
  function current() {
    var chosen = $$('[data-ccp-opt]:checked', form).map(function (r) { return r.value; });
    return variants.filter(function (v) { return chosen.every(function (c, i) { return v.options[i] === c; }); })[0];
  }
  function paint(v) {
    add.disabled = !v || !v.available;
    add.textContent = !v ? T('unavailable', 'Unavailable') : v.available ? T('add_to_cart', 'Add to cart') : T('sold_out', 'Sold out');
    if (!v) return;
    idField.value = v.id;
    price.innerHTML = '';
    var b = document.createElement('b'); b.textContent = window.CC.money(v.price); price.appendChild(b);
    if (v.compare_at_price > v.price) {
      var s = document.createElement('s'), em = document.createElement('em');
      s.textContent = window.CC.money(v.compare_at_price);
      em.textContent = T('save_pct', 'Save {pct}%', { pct: Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) });
      price.appendChild(s); price.appendChild(em);
    }
  }
  form.addEventListener('change', function (e) { if (e.target.hasAttribute('data-ccp-opt')) paint(current()); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var label = add.textContent;
    add.disabled = true; add.textContent = T('adding', 'Adding…');
    window.CC.add([{ id: Number(idField.value), quantity: 1 }])
      .catch(function () {})
      .then(function () { add.disabled = false; add.textContent = label; });
  });
})();
